import { render, staticRenderFns } from "./Nodi.vue?vue&type=template&id=62c1af9e&"
import script from "./Nodi.vue?vue&type=script&lang=js&"
export * from "./Nodi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports